<template>
    <v-dialog v-if="dialog" :value="dialog" persistent max-width="500">
        <v-card>
        <v-card-title class="headline">
          Ikke aktivert
        </v-card-title>

        <v-card-text>
         "Salongen du har valgt å reservere produkter fra er ikke lenger tilgjengelig for klikk & hent!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :href="homePageUrl"
            color="primary"
          >
            Tilbake
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins.js'
export default {
  mixins: [webshopMixins],
    props: {
        dialog: Boolean
    },
    computed:{
      homePageUrl() {
            return this.webshopSettings.chainHomePageUrl ?  `${this.webshopSettings.chainHomePageUrl.substr(0, 4) == 'http' ? '' : '//'}${this.webshopSettings.chainHomePageUrl}` : `/`
        },
    },
    methods:{
        
    }
}
</script>
<style scoped>
.v-dialog__content--active{
	z-index: 501;
}
</style>